export default "__VITE_ASSET__C6uAq5as__"